import { CustomSelector } from "../ui/components/CustomSelector";

export class LanguageChoice extends CustomSelector {
    init() {
        super.init();
        this.includeComponents({
            TranscriberSettings: "document@#TranscriberSettings",
        });
    }

    handleOptionSelect(e, optionComponent) {
        e.stopPropagation();

        let text = optionComponent.textContent;
        let languageCode = optionComponent.getAttribute("data-language-code");

        if (this.selectedText) {
            this.setSelectedLabel(text);
        }

        this.closeOptions();

        this.TranscriberSettings?.open({
            selectedLanguage: text,
            languageCode: languageCode,
        });

        if (this.selectedText && this.selectedText.default_lang) {
            this.selectedText.element.textContent = this.selectedText.default_lang;
        }

        this.selectedLabel = null;
    }
}
